<template>
  <div class="reg-merge__profile-info">
    <div class="reg-merge__account-section">
      <p><span class="ds1-utd-weight-600">Name:</span> {{ fullName }}</p>
      <p><span class="ds1-utd-weight-600">Email:</span> {{ mergeProfile.email }}</p>
    </div>
    <div v-if="showRoleSpecialty" class="reg-merge__account-section">
      <p><span class="ds1-utd-weight-600">Role:</span> {{ mergeProfile.role }}</p>
      <p><span class="ds1-utd-weight-600">Specialty:</span> {{ mergeProfile.specialty }}</p>
      <p>
        <span class="ds1-utd-weight-600">Practice Setting:</span> 
        {{ mergeProfile.practiceSetting }}
      </p>
    </div>
    <div v-if="isIndividualSubscriber" class="reg-merge__account-section">
      <p><span class="ds1-utd-weight-600">Phone:</span> {{ mergeProfile.phone }}</p>
      <p><span class="ds1-utd-weight-600">Address:</span></p>
      <p v-if="mergeProfile.addressLine1" class="reg-merge__address-line">
        {{ mergeProfile.addressLine1 }}
      </p>
      <p v-if="mergeProfile.addressLine2" class="reg-merge__address-line">
        {{ mergeProfile.addressLine2 }}
      </p>
      <p v-if="mergeProfile.addressLine3" class="reg-merge__address-line">
        {{ mergeProfile.addressLine3 }}
      </p>
      <p class="reg-merge__address-line">
        {{ mergeProfile.city }}<template v-if="showComma">, </template>
        {{ mergeProfile.state }} 
        {{ mergeProfile.zip }}
      </p>
      <p class="reg-merge__address-line">
        {{ countryName }}
      </p>
    </div>
    <div v-else class="reg-merge__account-section">
      <p><span class="ds1-utd-weight-600">Country:</span> {{ countryName }}</p>
      <p v-if="isDomestic">
        <span class="ds1-utd-weight-600">ZIP/Postal Code:</span> {{ mergeProfile.zip }}
      </p>
      <p v-else>
        <span class="ds1-utd-weight-600">City:</span> {{ mergeProfile.city }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const { mergeProfile, isIndividualSubscriber } = defineProps({
    mergeProfile: {
        type: Object,
        default: () => ({})
    },
    isIndividualSubscriber: {
        type: Boolean,
        default: false
    }
});

const store = useStore();

const myAccountCountries = computed(() => store.getters['account/myAccountCountries']);
const showComma = computed(() => mergeProfile.city 
  && (mergeProfile.state || mergeProfile.zip));
const isDomestic = computed(() => mergeProfile.country === 'USA');
const showRoleSpecialty = computed(() => {
    return mergeProfile.role
      && mergeProfile.specialty;
});

const fullName = computed(() => {
    const { firstName, lastName } = mergeProfile;
    return [ firstName, lastName ].filter(Boolean).join(' ');
});

const countryName = computed(() => {
    const countryCode = mergeProfile.country;
    if (!countryCode) {
        return '';
    }
    const country = myAccountCountries.value.find(c => c.value === countryCode);
    return country?.label || countryCode;
});
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.reg-merge__profile-info {
  .ds1-utd-size-2();
}

.reg-merge__account-section:not(:last-child) {
  .ds1-mb-2();
}

.reg-merge__account-section p {
    .ds1-ma-0();
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>
